export enum EConfigurationType {
  ROLE_BASED = "ROLE_BASED",
  USER_BASED = "USER_BASED",
  USER_AND_ROLE_BASED = "USER_AND_ROLE_BASED",
  SYSTEM_BASED = "SYSTEM_BASED",
}
